// Dashboard.js - Dashboard limpio y simple
import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';

const Dashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  // Función para obtener el saludo según la hora
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Buenos días';
    if (hour < 18) return 'Buenas tardes';
    return 'Buenas noches';
  };

  // Función para obtener el nombre del usuario
  const getUserName = () => {
    if (user?.firstName && user?.lastName) {
      return `${user.firstName} ${user.lastName}`;
    }
    if (user?.email) {
      return user.email.split('@')[0];
    }
    return 'Usuario';
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-content">
        {/* Header de bienvenida */}
        <div className="dashboard-header">
          <h1 className="dashboard-title">
            {getGreeting()}, {getUserName()}
          </h1>
          <p className="dashboard-subtitle">
            Bienvenido al sistema Mafy - Manejo Automatizado Fiscal y Ágil
          </p>
        </div>

        {/* Contenido principal */}
        <div className="dashboard-main">
          <div className="welcome-card">
            <div className="welcome-icon">🚀</div>
            <h2>¡Todo listo para comenzar!</h2>
            <p>
              Este es tu dashboard principal. Desde aquí podrás acceder a todas las funcionalidades 
              del sistema usando el menú de navegación superior.
            </p>
            
            <div className="quick-actions">
              <h3>Accesos rápidos:</h3>
              <div className="action-buttons">
                <button 
                  className="action-btn"
                  onClick={() => navigate('/descarga-masiva/clientes')}
                >
                  <span className="btn-icon">🏢</span>
                  Gestionar Clientes
                </button>
                
                <button 
                  className="action-btn"
                  onClick={() => navigate('/facturacion/nueva')}
                >
                  <span className="btn-icon">🧾</span>
                  Nueva Factura
                </button>
                
                <button 
                  className="action-btn"
                  onClick={() => navigate('/descarga-masiva/descargas')}
                >
                  <span className="btn-icon">📥</span>
                  Descargas
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;